import React from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";

export default function ResponsiveTableWrapper({
  children,
  maxH = "600px",
  minTableWidth = "900px",
}) {
  const scrollbarTrackBg = useColorModeValue("gray.100", "gray.800");
  const scrollbarThumbBg = useColorModeValue("gray.400", "gray.600");
  const scrollbarThumbHoverBg = useColorModeValue("gray.500", "gray.500");
  const scrollbarBorderColor = useColorModeValue("gray.100", "gray.800");

  return (
    <Box w="100%" minW={0} overflow="hidden">
      <Box
        maxH={maxH}
        overflowX="auto"
        overflowY="auto"
        pb={2}
        sx={{
          "&::-webkit-scrollbar": {
            width: "10px",
            height: "10px",
          },
          "&::-webkit-scrollbar-track": {
            background: scrollbarTrackBg,
            borderRadius: "5px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: scrollbarThumbBg,
            borderRadius: "5px",
            border: "1px solid",
            borderColor: scrollbarBorderColor,
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: scrollbarThumbHoverBg,
          },
          "&::-webkit-scrollbar:horizontal": {
            height: "10px",
          },
        }}
      >
        <Box minW={minTableWidth} w="100%">
          {children}
        </Box>
      </Box>
    </Box>
  );
}
